import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SessionTimerService } from '../../../core/services/session-timer.service';
import { environment } from 'src/environments/environment';
import { MemoryStorageService } from 'src/app/core/services/memory-storage.service';

@Component({
    selector: 'app-assist-success',
    templateUrl: './assist-success.component.html',
    styleUrls: ['./assist-success.component.scss'],
})
export class AssistSuccessComponent implements OnInit {

    public destination = MemoryStorageService.getItem('destination') || '';

    public agentName = MemoryStorageService.getItem('agentName') || '';

    public redirect: string = '';

    constructor(private sessionTimerService: SessionTimerService, private route: ActivatedRoute, private spinner: NgxSpinnerService) { }

    public ngOnInit(): void {
        this.spinner.hide();
        this.sessionTimerService.SetShowTimer(false);
        this.sessionTimerService.stopTimer();
        this.clearLocalStorage();
        this.route.queryParamMap.subscribe(params => {
            var redirect = params.get('redirect');
            if (redirect && redirect !== 'undefined') {
                this.redirect = redirect;
            }
        });

    }

    goBack(): void {
        window.location.replace(this.redirect);
    }

    private clearLocalStorage() {
        if (environment.production) {
            localStorage.clear();
        }
    }
}
